import React from "react";
import { SovosBox, SovosLink, SovosTypography } from "mosaic-react";
import { createLink } from "colbi_web_ui/lib/utils";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const isEmptyAssociationCounter = (value) =>
    value === 0 || value === "0" || value === null || value === undefined || value === "";

const SettingsFilterLink = (props) => {
    const { value: cell } = props || {};
    const { proxy, params, history } = useGlobalValue();
    const href = createLink(undefined, proxy, cell, {
        ...params,
        ...(cell?.customParam || {}),
    });
    const displayLabel = isEmptyAssociationCounter(cell?.name) ? "N/A" : cell?.name;

    const handleClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (href && history) {
            history.push(href);
        }
    };

    if (!href || isEmptyAssociationCounter(cell?.name)) {
        return <SovosTypography variant="body2">{displayLabel}</SovosTypography>;
    }

    return (
        <SovosBox onClick={(event) => event.stopPropagation()}>
            <SovosLink href={href} onClick={handleClick}>
                {cell.name}
            </SovosLink>
        </SovosBox>
    );
};

export default SettingsFilterLink;
